export const feedbackI18NDe = {
    feedback: `Dein Feedback`,
    send: `Senden`,
};
